exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-width: 0) and (max-width: 410px) {\n.hider-vid-spacer[data-v-c2ef66dc] {\n    min-height: 0 !important;\n}\n}\ntextarea[data-v-c2ef66dc] {\n  -webkit-text-fill-color: #4a4a4a;\n  opacity: 1;\n}\n", ""]);

// exports
